module.exports = __webpack_public_path__ + "static/media/equipped-icon.4f372fb5.png";